import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import TollIcon from '@mui/icons-material/Toll';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { getReferralEligibilityCopy } from '../utils/referralEligibility';

export default function ReferralTokenTargetPill({ theme, isDark, eligibility, compact = false }) {
  if (!eligibility) return null;

  const copy = getReferralEligibilityCopy(eligibility);
  const met = !!eligibility.referralEligible && eligibility.messageKey === 'referral_target_met';
  const warn = !eligibility.referralEligible && eligibility.messageKey !== 'grace_active';
  const inGrace = !!eligibility.inGracePeriod;

  return (
    <Tooltip title={copy.tooltip} placement="top" enterTouchDelay={0}>
      <Box
        sx={{
          border: '1px solid',
          borderColor: met || inGrace
            ? alpha(theme.palette.success.main, isDark ? 0.45 : 0.35)
            : warn
              ? alpha(theme.palette.warning.main, 0.45)
              : alpha(theme.palette.divider, isDark ? 0.35 : 0.2),
          borderRadius: 999,
          px: compact ? { xs: 0.7, sm: 1 } : { xs: 0.85, sm: 1.2 },
          py: 0.45,
          flexShrink: 0,
          background: isDark
            ? `linear-gradient(135deg, ${alpha('#1c1618', 0.95)} 0%, ${alpha('#141012', 0.98)} 100%)`
            : alpha(theme.palette.background.paper, 0.95),
          boxShadow: warn && isDark ? `0 0 18px ${alpha(theme.palette.warning.main, 0.12)}` : 'none',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            color: 'common.white',
            fontSize: { xs: '0.8125rem', sm: '0.875rem' },
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.45,
            whiteSpace: 'nowrap',
          }}
        >
          <span>{copy.pill}</span>
          {met ? (
            <CheckCircleOutlineIcon sx={{ fontSize: 16, color: theme.palette.success.main }} aria-hidden />
          ) : (
            <TollIcon sx={{ fontSize: 16, color: theme.palette.warning.main }} aria-hidden />
          )}
        </Typography>
      </Box>
    </Tooltip>
  );
}

export function ReferralEligibilityBanner({ eligibility }) {
  const copy = getReferralEligibilityCopy(eligibility);
  if (!copy.banner) return null;
  return (
    <Typography variant="body2" sx={{ mb: 1, color: 'warning.main', fontWeight: 600 }}>
      {copy.banner}
    </Typography>
  );
}
